import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule, FormArray, FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { BASE_IMAGE_URL } from 'src/app/endpoints';
import { DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { SafeUrlPipe } from 'src/app/shared/pipe/safe_url/safe_url_pipe.pipe';
import { MatTabsModule } from '@angular/material/tabs';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CategoryService } from 'src/app/shared/service/category/category.service';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { UserDataService } from 'src/app/shared/service/userData/user-data.service';
import JsBarcode from 'jsbarcode';

declare var bootstrap: any;

@Component({
  selector: 'app-sample',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    MatIcon,
    ReactiveFormsModule,
    DatePipe,
    NgSelectModule,
    RouterLink,
    SafeUrlPipe,
    MatTabsModule,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatLabel,
    MatInputModule,
  ],
  templateUrl: './sample.component.html',
  styleUrl: './sample.component.scss'
})
export class SampleComponent {

  // Component variables
  sampleDetailModal: any;
  AssignSampleModal: any;
  startpoint: number = 0;
  search: any;
  totalLoaded: number = 0;
  total: any;
  pageNo: any;
  sampleId: any;
  name: any;
  pageSize: any;
  dataSource = new MatTableDataSource<any>([]);

  // Displayed columns are dynamically set based on user role
  displayedColumns: string[] = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('barcodeElement') barcodeElement!: ElementRef;

  // Filter and category/company data
  sampleData: any;
  wholeSalerTotal: any;
  retailerTotal: any;
  allCategoriesMini: any;
  allCompanies: any;

  // Reactive Form for assigning samples
  issueSampleForm = new FormGroup({
    rows: new FormArray([])
  });

  get rows() {
    return this.issueSampleForm.get('rows') as FormArray;
  }

  // Debounce handlers
  debounceNameTimer: any = null;
  debounceBarCodeTimer: any = null;

  // Sample search object
  sampleSearch: any = {
    name: '',
    barCode: '',
    category: undefined,
    company: undefined,
    startdate: null,
    enddate: null
  };

  isCompanyLoggedIn: boolean = false;

  constructor(
    private sampleService: SampleService,
    private categoryService: CategoryService,
    private companyService: CompanyService,
    public userDataService: UserDataService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.setDisplayedColumns();
  }

  // Configure displayed columns based on user role
  setDisplayedColumns(): void {
    this.displayedColumns = [
      'srno',
      'company',
      'name',
      'barcode',
      'totalItems',
      'leftItems',
      'createdAt',
      'isBlocked',
      'preview'
    ];

    if (this.userDataService.roleMatch(['SAMPLE-ASSIGN'])) {
      this.displayedColumns.push('assignSample');
    }
    if (this.userDataService.roleMatch(['SAMPLE-EDIT'])) {
      this.displayedColumns.push('action');
    }
  }

  isTodaySample: any = false;
  ngOnInit(): void {
    this.isTodaySample = this.activatedRoute.snapshot.queryParamMap.get("isTodaySample");
    if (this.isTodaySample === 'true') {
      const today = new Date();
      this.sampleSearch.startdate = today;
      this.sampleSearch.enddate = today;
    }
    this.getAllCategoriesMini();
    this.allCompaniesMini();
    this.getCompanyData();


  }

  // Handle filter change
  sampleFilter(event: any): void {
    this.getAllSamples(null);
  }

  // Fetch all minimal categories
  getAllCategoriesMini(): void {
    this.categoryService.allCategoriesMini({}).subscribe({
      next: (res) => {
        if (res.success) this.allCategoriesMini = res.data;
      },
      error: (e) => this.toastr.error(e)
    });
  }

  // Handle debounce for name input
  onNameInputChange(event: any): void {
    clearTimeout(this.debounceNameTimer);
    this.debounceNameTimer = setTimeout(() => {
      const name = event.target.value.trim();
      this.sampleSearch.name = name || undefined;
      this.getAllSamples(null);
    }, 300);
  }

  // Handle debounce for barcode input
  onBarCodeInputChange(event: any): void {
    clearTimeout(this.debounceBarCodeTimer);
    this.debounceBarCodeTimer = setTimeout(() => {
      const code = event.target.value.trim();
      this.sampleSearch.barCode = code || undefined;
      this.getAllSamples(null);
    }, 300);
  }

  // Clear selected date range
  clearDateRange(): void {
    this.sampleSearch.startdate = null;
    this.sampleSearch.enddate = null;
    this.getAllSamples(null);
  }

  // Check if user has a company linked and fetch data accordingly
  getCompanyData() {
    let userData = this.userDataService.getData();
    let companyData = userData.company;
    if (!!companyData) {
      this.isCompanyLoggedIn = true;
      this.sampleSearch.company = companyData._id;
      this.getAllSamples(null);
    } else {
      this.isCompanyLoggedIn = false;
      this.getAllSamples(null);
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    const sampleDetailModalElement = document.getElementById('sampleDetailModal');
    if (sampleDetailModalElement) {
      this.sampleDetailModal = new bootstrap.Modal(sampleDetailModalElement);
    }
  }

  // Generate barcode using JsBarcode
  getSampleCode(sampleCode: any) {
    if (this.barcodeElement?.nativeElement && sampleCode) {
      JsBarcode(this.barcodeElement.nativeElement, sampleCode, {
        format: 'CODE128',
        lineColor: '#000000',
        background: '#ffffff',
        width: 1.5,
        height: 40,
        fontSize: 12,
        displayValue: true
      });
    } else {
      console.warn("Barcode element or sample code missing");
    }
  }

  // Generate full image path from base
  getImg(imgPath: any) {
    return BASE_IMAGE_URL + imgPath;
  }

  // Fetch all companies
  allCompaniesMini() {
    this.companyService.allCompaniesMini({}).subscribe({
      next: (result) => {
        if (result.success) this.allCompanies = result.data;
      },
      error: (e) => this.toastr.error(e)
    });
  }

  // Open modal to view sample details
  openModel(sampleId: any) {
    this.sampleId = sampleId;
    if (sampleId !== null) this.getSingleSample(sampleId);
    this.sampleDetailModal.show();
  }

  // Hide sample details modal
  hideModel() {
    this.sampleDetailModal.hide();
  }

  // Fetch single sample data by ID
  getSingleSample(sampleId: any) {
    this.spinner.show();
    this.sampleService.singleSample({ _id: sampleId }).subscribe({
      next: (v: any) => {
        if (v.success) this.sampleData = v.data;
        else console.log(v.message);
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      },
      complete: () => this.spinner.hide()
    });
  }

  // Fetch all samples with current filters and pagination
  getAllSamples(event: any) {
    this.spinner.show();
    if (!event) {
      this.pageNo = 0;
      this.startpoint = 0;
      this.pageSize = this.pageSize || 10;
      this.dataSource.data = [];
    }
    if (event?.pageSize && event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.pageNo = 0;
      this.startpoint = 0;
      this.dataSource.data = [];
    }
    if (event?.pageIndex !== undefined) {
      this.pageNo = event.pageIndex;
      this.startpoint = this.pageNo * (this.pageSize || 10);
    }

    const data: any = {
      startpoint: this.startpoint,
      limit: this.pageSize,
      name: this.sampleSearch.name || undefined,
      sampleCode: this.sampleSearch.barCode || undefined,
      categoryId: this.sampleSearch.category || undefined,
      startdate: this.sampleSearch.startdate || undefined,
      enddate: this.sampleSearch.enddate || undefined,
      companyId: this.sampleSearch.company || undefined
    };

    this.sampleService.allSamples(data).subscribe({
      next: (result) => {
        if (result?.success) {
          this.total = result.total ?? 0;
          this.dataSource.data = result.data || [];
          setTimeout(() => {
            if (this.paginator) {
              this.paginator.pageIndex = this.pageNo;
              this.paginator.length = this.total;
              this.paginator.pageSize = this.pageSize;
            }
          }, 0);
        }
      },
      error: (error: any) => {
        let errorMsg = "An unexpected error occurred.";
        if (error.status === 0) {
          errorMsg = "Server not reachable. Please check your network connection.";
        } else if (error.error?.message) {
          errorMsg = error.error.message;
        } else if (error.message) {
          errorMsg = error.message;
        }
        this.toastr.error(errorMsg, "Error");
        console.error("Sample Fetch Error:", error);
      },
      complete: () => this.spinner.hide()
    });
  }

  // Toggle sample status (blocked/unblocked) with confirmation
  sampleStatus(element: any) {
    const currentStatus = element.isBlocked;
    const newStatus = !currentStatus;
    const action = newStatus ? 'Block' : 'Unblock';
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: `${action} this Sample?`,
        text: `This will ${action.toLowerCase()} the Sample.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `${action}`,
        cancelButtonText: 'Cancel',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.sampleService
            .enableDisableSample({ _id: element._id, isBlocked: newStatus })
            .subscribe({
              next: (v: any) => {
                if (v.success) {
                  element.isBlocked = newStatus;
                  this.toastr.success(`Sample ${action.toLowerCase()}ed successfully.`);
                } else {
                  this.toastr.error(v.message, 'Error');
                }
              },
              error: (e: any) => {
                this.toastr.error(e.message, 'Error');
              },
            });
        }
      });
    return false;
  }
}
